import { routePaths } from '../../../routePaths';
import { translate } from '../../../utils';
import { WarehousePermission } from '../../../generated/graphql';
import { RouteType } from '../../../types';
import { CreateWarehouseCategoryForm, UpdateWarehouseCategoryForm, WarehouseCategoriesPage } from '../../../modules/warehouseCategories';

const WarehouseCategoriesRoute: RouteType = {
    exact: false,
    showInSideBar: true,
    path: routePaths.warehouseCategories,
    title: translate('Warehouse Categories'),
    permissions: {
        warehouse: [WarehousePermission.CanViewStockCardCategory],
    },
    component: WarehouseCategoriesPage,
    redirectRoute: routePaths.warehouse,
    childrenRoutes: [
        {
            exact: true,
            path: routePaths.warehouseCategoriesCreate,
            component: CreateWarehouseCategoryForm,
            title: translate('New warehouse category'),
            permissions: { warehouse: [WarehousePermission.CanAddStockCardCategory] },
            redirectRoute: routePaths.warehouseCategories,
        },
        {
            exact: true,
            path: routePaths.warehouseCategoriesUpdate,
            component: UpdateWarehouseCategoryForm,
            title: translate('Update warehouse category'),
            permissions: { warehouse: [WarehousePermission.CanUpdateStockCardCategory] },
            redirectRoute: routePaths.warehouseCategories,
        }
    ],
};

export default WarehouseCategoriesRoute;
